import React from 'react';

import {Row, Column} from '../../global/grid/grid';

import { H1 } from '../../global/typography/typography';

const LargeText = ({data}) => {
  return (
    <div>
        <Row margins={true} style={{ alignItems: 'center' }}>
          <Column cw={4} offset={1}>
            <H1>{data.text}</H1>
          </Column>
        </Row>
    </div>
  )
}

export default LargeText;



// WEBPACK FOOTER //
// ./src/components/modules/LargeText/LargeText.js